import { render, staticRenderFns } from "./LifeInsuranceView.vue?vue&type=template&id=a6705b08&scoped=true"
import script from "./LifeInsuranceView.vue?vue&type=script&lang=ts"
export * from "./LifeInsuranceView.vue?vue&type=script&lang=ts"
import style0 from "./LifeInsuranceView.vue?vue&type=style&index=0&id=a6705b08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6705b08",
  null
  
)

export default component.exports